import { createContext, useContext } from 'react';

import type { LensFilterValues } from '~/types/leLens';

type NativePrintSession = { lensId: string; filters: LensFilterValues };

export const NativePrintMode = createContext(false);

export const useNativePrintMode = () => useContext(NativePrintMode);

let session: NativePrintSession | null = null;

export function beginNativePrint(lensId: string, filters: LensFilterValues) {
  session = { lensId, filters };
}

export function nativePrintSession(): NativePrintSession | null {
  return session;
}
